import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"
import { WarrantMeterExchangeService } from "@/services/WarrantMeterExchangeService"

export const getMeterExchangeEligibility = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  const eligibilityQuery = WarrantMeterExchangeService.getEligibility(
    coreIdQuery.data,
  )

  queries.add(coreIdQuery)
  queries.add(eligibilityQuery)

  return queries.setData(eligibilityQuery.data).getAggregate()
}
